<script>
import { YunIcon } from '@yld/yun-icon'
export default {
  name: 'MenuItem',
  components: {
    YunIcon
  },
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      vnodes.push(<yun-icon className="yun-menu-icon" name={icon} />)
    }

    if (title) {
      vnodes.push(<span slot='title'>{title}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
.yun-menu-icon {
  font-size: 20px;
  margin-bottom: 1px;
  padding: 2px;
}
</style>
